import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class MaintenanceInterventionTypesEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: { message: '', type: '', status: 'open' },
      loaded: 0,
      id: null,
      aircraft_model_id: null,
      type: '',
      aircraft_models_select: [],
    };
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  handleChange (name, event) { var change = {}; change[name] = event.target.value; this.setState(change); }
  handleSelectChange(name, event) { var change = {}; change[name] = event ? event.value : null; this.setState(change); }
  handleAlert(m,t,s,m2) { if(m2==='reset'){ this.setState({overlay:{message:'',type:'',status:'closed'}});} else { this.setState({overlay:{message:m,type:t,status:s}});} }
  handleLoaded(state) { if(this.state.loaded !== 2) { this.setState({loaded: state}); } }
  handleMessage () { var m = localStorage.getItem("verify_message"); if(m){ m=JSON.parse(m); this.setState({overlay:{message:m.alert_message,type:m.alert_type,status:'open'}}); localStorage.removeItem("verify_message"); } }
  componentDidMount () { this.refs.request_api.header(); }
  componentDidUpdate(prevProps, prevState) { if(this.state.loaded===1 && prevState.loaded===0){ this.setState({loaded:2}, this.loadData()); } }
  loadData () {
    var self = this; var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/manutencao/intervencao/'+self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((r)=>r.json()).catch((e)=>{ console.error(e); }).then((responseJson)=>{
        self.refs.request_api.validate(responseJson, 'url', '/manutencao/intervencoes');
        if (responseJson.status === 'success') {
          self.setState({ id: responseJson.data.id, aircraft_model_id: responseJson.data.aircraft_model_id, type: responseJson.data.type });
        }
      }).then(()=>{
        fetch(config.get('api') + '/aeronave/modelo/lista', { method: 'GET', mode: 'cors', headers: value }).then((r)=>r.json()).catch((e)=>{ console.error(e); }).then((responseJson)=>{
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') { self.setState({ aircraft_models_select: responseJson.data }); }
        }).then(()=>{ self.setState({overlay:{message:'',type:'',status:'closed'}}); self.handleMessage(); });
      });
    });
  }
  edit(event) {
    event.preventDefault(); this.handleAlert('', '', 'open');
    var datasave = { id: this.state.id, aircraft_model_id: this.state.aircraft_model_id, type: this.state.type };
    var self = this; var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/manutencao/intervencao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((r)=>r.json()).catch((e)=>{ console.error(e); }).then((responseJson)=>{
        self.refs.request_api.validate(responseJson, 'alert'); self.handleAlert(responseJson.message, responseJson.status, 'open');
      });
    });
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Editar Tipo de Intervenção de Manutenção</h3>
      <Link to="/manutencao/intervencoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6"><div className="form-group">
            <label>Modelo:</label>
            <Select className="form-field-name" name="aircraft_model_id" value={this.state.aircraft_model_id} searchable={true} placeholder={''} onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')} options={this.state.aircraft_models_select} />
          </div></div>
          <div className="col-md-6"><div className="form-group">
            <label>Tipo:</label>
            <input type="text" className="form-control" name="type" value={this.state.type} onChange={this.handleChange.bind(this, 'type')} />
          </div></div>
        </div>
        <div className="row"><div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
        </div></div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default MaintenanceInterventionTypesEdit;



// WEBPACK FOOTER //
// ./src/Components/MaintenanceInterventionTypes/MaintenanceInterventionTypesEdit.js